import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [visibility, setVisibility] = useState({ oscar_greven: true });

  useEffect(() => {
    fetchVisibility();
  }, []);

  const fetchVisibility = async () => {
    try {
      const response = await axios.get(`${API}/services/visibility`);
      setVisibility(response.data);
    } catch (error) {
      console.error('Error fetching visibility:', error);
    }
  };

  const allInstructors = [
    {
      id: 'julie',
      name: 'Julie Christiansen',
      title: '3x World Champion • 3x Nordic Champion • 26x Danish Champion',
      description: t('World-class training'),
      image: 'https://customer-assets.emergentagent.com/job_eduslots-6/artifacts/yr6uovu2_Julie.jpg',
      path: '/julie-options',
      alwaysVisible: true  // Julie has multiple services, always show her
    },
    {
      id: 'oscar',
      name: 'Óskar Erik Kristjánsson',
      title: '2x Nordic Champion • 3x German Youth Champion • 10x Danish Champion',
      description: t('Rising star'),
      image: 'https://customer-assets.emergentagent.com/job_eduslots-6/artifacts/95ukofjv_thumbnail_image0%20%281%29.jpg',
      path: '/teaching-oscar',
      alwaysVisible: false,
      visibilityKey: 'oscar_greven'
    }
  ];

  // Filter instructors based on visibility
  const instructors = allInstructors.filter(instructor => {
    if (instructor.alwaysVisible) return true;
    return visibility[instructor.visibilityKey];
  });

  return (
    <div>
      <Navbar />
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title" data-testid="hero-title">
            <span className="jcp-logo-hero">JCP</span> Teaching
          </h1>
          <p className="hero-subtitle">{t('Experience world-class training')}</p>
          
          <div className="instructor-grid" style={{ maxWidth: '1000px', marginTop: '3rem' }}>
            {instructors.map((instructor) => (
              <div 
                key={instructor.id}
                className="instructor-card"
                onClick={() => navigate(instructor.path)}
                data-testid={`instructor-card-${instructor.id}`}
              >
                <img 
                  src={instructor.image} 
                  alt={instructor.name}
                  className={`instructor-image ${instructor.id === 'oscar' ? 'instructor-image-oscar' : ''}`}
                />
                <h2 className="instructor-name">{instructor.name}</h2>
                <p className="instructor-title">{instructor.title}</p>
                <p className="instructor-description">{instructor.description}</p>
                <button className="cta-button" data-testid={`cta-button-${instructor.id}`}>
                  {t('Learn more')}
                  <ArrowRight size={18} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;